var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{attrs:{"type":"donut","options":_vm.chartOptions,"series":_vm.values}})}
var staticRenderFns = []

export { render, staticRenderFns }